import { format, isValid, parse } from 'date-fns';
import { z } from 'zod';

export const UNAVAILABLE_DETACH_DATE_MESSAGE = 'Выбранная дата недоступна';

export const validationDateDetach = z.object({
  detach_date: z.string(),
});

export type DateDetachParams = z.infer<typeof validationDateDetach>;

export type DetachDateChangeResult =
  | { kind: 'empty' }
  | { kind: 'incomplete'; displayDate: string }
  | { kind: 'unavailable'; displayDate: string }
  | { kind: 'valid'; displayDate: string; formDate: string };

export function resolveDetachDateChange(
  newValue: string | undefined,
  isDateDisabled: (date: Date) => boolean
): DetachDateChangeResult {
  if (!newValue) {
    return { kind: 'empty' };
  }

  const parsedDate = parse(newValue, 'dd.MM.yyyy', new Date());
  if (!isValid(parsedDate)) {
    return { kind: 'incomplete', displayDate: newValue };
  }

  if (isDateDisabled(parsedDate)) {
    return { kind: 'unavailable', displayDate: newValue };
  }

  return {
    kind: 'valid',
    displayDate: newValue,
    formDate: format(parsedDate, 'yyyy-MM-dd'),
  };
}
